module.exports = __webpack_public_path__ + "img/cloud-sun.e340831b.svg";